import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar, EventSourceApi } from '@fullcalendar/core';
import { CalendarOpts } from "./calendar";

export function initCalSpecDays(cal: Calendar, opts: CalendarOpts) {
  p('initCalSpecDays');
  if (!opts.spec_days) return;

  const calendar = cal;
  Cookies.set('spec_day_back', window.location.href, { path: '/' });
  Cookies.set('user_back', window.location.href, { path: '/' });

  let source: EventSourceApi | null = null;
  let active = !(Cookies.get('cal_no_specdays') == 'true');

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default margin-left-5px margin-bottom-5px toggle-calendar-specdays',
    html: '<i class="fa fa-sun-o"></i> Távollétek'
  });
  $('#btnContainer').append(btn);
  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  // create button dynamically
  const btnNew = $('<button>', {
    class: 'btn btn-default margin-5px new-calendar-specday',
    html: '<i class="fa fa-sun-o"></i> Új távollét'
  });
  $('#btnNewContainer').append(btnNew);
  btnNew.on('click', function () {
    const newQuery = $("#modalNewEntry").data("new-query");
    window.location.replace("/spec_days/new?" + newQuery);
  });

  refresh();

  function refresh() {
    active ? btn.addClass('active') : btn.removeClass('active');
    active ? $(btnNew).show() : $(btnNew).hide();
    Cookies.set('cal_no_specdays', (!active) + '', {
      expires: 10,
      path: '/'
    });
    if (source) {
      active ? calendar.addEventSource(source) : source.remove();
    } else if (active) {
      source = calendar.addEventSource({
        url: '/spec_days.json',
        extraParams: {
          'q[user_id_eq]': opts.user_id
        }
      });
    }
  }
}